import { useReactiveVar } from "@apollo/client";
import { useMemo } from "react";

import { Button } from "@/components/ui/button";
import useAnalytics from "@/hooks/use-analytics";
import { cn } from "@/lib/utils";
import { user as userStore } from "@/store";

import { PencilIcon } from "./icons";

interface SuggestEditProps {
  className?: string;
  gameId: string;
}

export default function SuggestEdit({ className, gameId }: SuggestEditProps) {
  const { track } = useAnalytics();
  const user = useReactiveVar(userStore);

  const userId = useMemo(() => (user ? `&user_id=${user.id}` : ""), [user]);

  return (
    <div
      className={cn(
        "flex items-center justify-between rounded-[15px] bg-white/5 px-4 py-2.5 md:rounded-[20px] md:px-7 md:py-6",
        className
      )}
    >
      <div className="flex flex-col items-start">
        <p className="font-medium text-13/[1.54em] text-white md:text-16/[1.18em]">
          Found an issue?
        </p>
        <p className="text-13/[1.54em] text-cool-gray md:mt-1 md:text-15/[1.33em]">
          Let us know!
        </p>
      </div>
      <Button
        asChild
        className="flex h-[37px] rounded-[18px] bg-linear-225 from-50% from-bright-pink to-dark-magenta px-3 font-medium text-14/[1.2em] text-white shadow-purple-plum/60 transition-shadow hover:no-underline hover:shadow-0-0-30"
        onClick={() => {
          track("Suggest an Edit Button Tapped", { game_id: gameId });
        }}
      >
        <a
          href={process.env.SUGGEST_EDIT_URL + gameId + userId}
          rel="noopener noreferrer"
          target="_blank"
        >
          <PencilIcon className="text-white" />
          Suggest an edit
        </a>
      </Button>
    </div>
  );
}
